export default "__VITE_ASSET__275524eb__"